/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 4fjEYDyHsDvAphaYRHZchB

import { createUseStyleTokens } from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 4fjEYDyHsDvAphaYRHZchB/projectModule

import projectcss from "./plasmic.module.css"; // plasmic-import: 4fjEYDyHsDvAphaYRHZchB/projectcss

import plasmic_paziresh_24_design_system_css from "../launcher/plasmic.module.css"; // plasmic-import: 6HBcNwr8dz9LuS1Qe36xa5/projectcss

const data = {
  base: `${projectcss.plasmic_tokens} ${plasmic_paziresh_24_design_system_css.plasmic_tokens}`,
  varianted: []
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
